import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-table-empty-state[text1]',
    templateUrl: './table-empty-state.component.html',
    styleUrls: ['./table-empty-state.component.scss'],
    standalone: true,
    imports: [RouterModule],
})
export class TableEmptyStateComponent {
    @Input() text1: string = '';
    @Input() text2: string = '';
    @Input() btnText: string = '';
    @Input() btnLink: string | null = null;
    @Input() icon: string = 'fa-duotone fa-cart-plus';
}
